var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationObserver", {
    ref: "observer",
    staticClass: "w-full",
    attrs: { tag: "div" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ invalid, dirty, handleSubmit }) {
          return [
            _c("ValidationProvider", {
              attrs: {
                name: _vm.capitalizedSubject,
                rules: "min_value:0|max_value:1000000000|integer",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ errors }) {
                      return [
                        _c(
                          "form",
                          {
                            staticClass: "flex w-full",
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return handleSubmit(_vm.updateHours)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-baseline text-label font-bold",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "whitespace-no-wrap",
                                    class: _vm.labelClasses,
                                  },
                                  [
                                    _c("span", { staticClass: "capitalize" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.capitalizedSubject) +
                                          " "
                                      ),
                                    ]),
                                    _vm.subjectAddition
                                      ? _c(
                                          "span",
                                          { staticClass: "subject_addition" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.subjectAddition) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c("p", { staticClass: "mr-2 min-w-10" }, [
                                  _vm._v(" " + _vm._s(_vm.shownAmount) + " "),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "w-16 mr-2" },
                                  [
                                    _c("PrefixedFormInput", {
                                      attrs: {
                                        type: "number",
                                        placeholder: _vm.defaultPlaceholder,
                                        height: "sm",
                                        inputClass: "bg-white font-bold",
                                        prefix: _vm.inputPrefix,
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.$emit("blur")
                                        },
                                      },
                                      model: {
                                        value: _vm.amount,
                                        callback: function ($$v) {
                                          _vm.amount = $$v
                                        },
                                        expression: "amount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("CardBodyButton", {
                              attrs: {
                                disabled:
                                  _vm.buttonDisabled || invalid || !dirty,
                                buttonText: _vm.buttonContent,
                              },
                              on: {
                                click: function ($event) {
                                  return handleSubmit(_vm.updateHours)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._l(errors, function (error, index) {
                          return _c("FormGroupError", {
                            key: index,
                            attrs: { error: error },
                          })
                        }),
                        _vm.description
                          ? _c("p", { staticClass: "text-label" }, [
                              _vm._v(" " + _vm._s(_vm.description) + " "),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }